document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-participant-names]').forEach((wrapper) => {
    const fieldsContainer = wrapper.querySelector('[data-participant-fields]');
    const formId = wrapper.dataset.formId;

    const productContainer = wrapper.closest(
      'product-info, .product__info-container, .product'
    );

    const quantityInput =
      productContainer?.querySelector('input[name="quantity"]') ||
      document.querySelector(`input[name="quantity"][form="${formId}"]`);

    if (!fieldsContainer || !quantityInput) return;

    const updateParticipantInputs = () => {
      const quantity = Math.max(
        1,
        parseInt(quantityInput.value, 10) || 1
      );

      const currentValues = Array.from(
        fieldsContainer.querySelectorAll('input')
      ).map((input) => input.value);

      fieldsContainer.innerHTML = '';

      for (let index = 1; index <= quantity; index++) {
        const input = document.createElement('input');

        input.type = 'text';
        input.id = `ParticipantName-${formId}-${index}`;
        input.className = 'participant-names__input';

        input.name =
          quantity === 1
            ? 'properties[Name des Teilnehmers]'
            : `properties[Name des Teilnehmers ${index}]`;

        input.placeholder =
          quantity === 1
            ? 'Name des Teilnehmers'
            : `Name des Teilnehmers ${index}`;

        input.value = currentValues[index - 1] || '';
        input.setAttribute('form', formId);

        fieldsContainer.appendChild(input);
      }
    };

    updateParticipantInputs();

    quantityInput.addEventListener('input', updateParticipantInputs);
    quantityInput.addEventListener('change', updateParticipantInputs);

    const quantityWrapper = quantityInput.closest('quantity-input');

    quantityWrapper?.addEventListener('click', () => {
      setTimeout(updateParticipantInputs, 0);
    });
  });
});